// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bck_a bha_b bha_tu bha_qz bha_ra bha_uo","PanelFooter--link":"bck_b"};